module.exports = {
  'flavor_name':'default_flavor',
  'type': 'VSAAS',
  'container': {
    'NVR': 'disable',
    'PROXYCAM': 'disable',
    'LIVEVIEW': 'disable',
    'E2C': 'disable',
    'DOCKER': 'disable',
    'AI': 'disable',
    'test_sequence': 'disable'
  }
}
